import EventEmitter from "./EventEmitter";
export default class MobileKeyboard extends EventEmitter {
  constructor(isPortrait = false) {
    super();
    this.container = document.createElement("div");
    this.container.id = "mobile_keyboard";
    if (isPortrait) this.container.classList.add("portrait");
    this.wrapper = document.createElement("div");
    this.wrapper.classList.add("lettersWrapper");
    // create a slidable list of letters
    // that can be used to type in the text box
    this.letters = "abcdefghijklmnopqrstuvwxyz".split("");

    this.letters.forEach((letter) => {
      const letterEl = document.createElement("div");
      letterEl.classList.add("letter");
      letterEl.textContent = letter;
      letterEl.ariaLabel = letter;
      letterEl.dataset.letter = letter;
      this.wrapper.appendChild(letterEl);
    });

    this.container.appendChild(this.wrapper);
    document.body.appendChild(this.container);
    console.log(this.container.clientWidth);

    this.progress = 0;
    this.speed = 0;
    this.oldX = 0;
    this.x = 0;
    this.playrate = 0;

    this.calculate();
    this.initListeners();
  }

  resize(isPortrait = false) {
    if (isPortrait) {
      this.container.classList.add("portrait");
    } else {
      this.container.classList.remove("portrait");
    }
    this.calculate();
  }

  initListeners() {
    this.handlers = {
      touchStart: this.onTouchStart.bind(this),
      touchMove: this.onTouchMove.bind(this),
      touchEnd: this.onTouchEnd.bind(this),
    };
    this.container.addEventListener("touchstart", this.handlers.touchStart, {
      passive: false,
    });
    this.container.addEventListener("touchmove", this.handlers.touchMove, {
      passive: false,
    });
    this.container.addEventListener("touchend", this.handlers.touchEnd, {
      passive: false,
    });
  }
  onTouchStart(e) {
    e.preventDefault();
    this.dragging = true;
    this.startX = e.clientX || e.changedTouches[0].clientX;
    this.wrapper.classList.add("dragging");
    // click
    this.firstX = this.startX;
  }
  onTouchMove(e) {
    e.preventDefault();
    if (!this.dragging) return false;
    const x = e.clientX || e.changedTouches[0].clientX;
    this.progress += (this.startX - x) * 2.5;
    this.startX = x;
    // this.$wrap.style.transform = `translateX(${-this.x}px)`;
    this.move();
  }
  onTouchEnd(e) {
    e.preventDefault();
    this.dragging = false;
    this.wrapper.classList.remove("dragging");
    const x = e.clientX || e.changedTouches[0].clientX;
    if (this.dist(this.firstX, 0, x, 0) < 5) {
      //   this.onClick(e);
      if (e.target.dataset.letter)
        console.log("click", e.target.dataset.letter);
      this.emit("keydown", [{ key: e.target.dataset.letter }]);
    }
  }

  calculate() {
    const margin = 3;
    this.progress = 0;
    if (this.container.classList.contains("portrait")) {
      this.wrapWidth = (44 + 2 * margin) * Math.ceil(this.letters.length / 4);
    } else {
      this.wrapWidth = (44 + 2 * margin) * this.letters.length;
    }

    this.wrapper.style.width = `${this.wrapWidth}px`;
    this.maxScroll = this.wrapWidth - this.container.clientWidth;
  }

  move() {
    this.progress = this.clamp(this.progress, 0, this.maxScroll);
  }

  update() {
    this.x = this.lerp(this.x, this.progress, 0.3);
    this.playrate = this.x / this.maxScroll;
    //
    this.wrapper.style.transform = `translateX(${-this.x}px)`;

    this.speed = Math.min(100, this.oldX - this.x);
    this.oldX = this.x;
    //
    // this.scale = this.lerp(this.scale, this.speed, 0.1);
    // this.$items.forEach((i) => {
    //   i.style.transform = `scale(${1 - Math.abs(this.speed) * 0.002})`;
    //   i.querySelector("img").style.transform = `scaleX(${
    //     1 + Math.abs(this.speed) * 0.004
    //   })`;
    // });
  }

  lerp(f0, f1, t) {
    return (1 - t) * f0 + t * f1;
  }
  clamp(val, min, max) {
    return Math.max(min, Math.min(val, max));
  }
  dist(x0, y0, x1, y1) {
    return Math.sqrt((x1 - x0) ** 2 + (y1 - y0) ** 2);
  }

  show() {
    this.container.classList.add("active");
  }

  hide() {
    this.container.classList.remove("active");
  }
}
